import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import Card from 'components/Card'
import withStyle from './CardList.style.js'

const CardList = ({ className, cards, cardSize }) => (
  <>
    <div className={classNames(className, 'card-list')}>
      {cards.map((card, index) => (
        <Card key={card.key} {...card} index={index} cardSize={cardSize} />
      ))}
    </div>
  </>
)

CardList.defaultProps = {
  cards: [],
  cardSize: {},
}

CardList.propTypes = {
  className: PropTypes.string,
  cardSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      onClick: PropTypes.func,
      onClickDisabled: PropTypes.bool,
      linkUri: PropTypes.string,
      linkIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      linkDisabled: PropTypes.bool,
      linkShow: PropTypes.bool,
      selected: PropTypes.bool,
    })
  ),
}

export default withStyle(CardList)
